import Loader from '../components/Loader';
import { FcGoogle } from "react-icons/fc";
import { useEffect, useState } from "react";
import Header from '../components/headerfooter/Header';
import Footer from '../components/headerfooter/Footer';
import MobileFooter from '../components/MobileFooter';
import CallToAction from '../components/home/CallToAction';
import { auth, provider } from '../firebase/firebase';
import {  signInWithPopup } from 'firebase/auth';
import { useNavigate, useParams } from 'react-router';
import { getDecryptedData, storeEncryptedData } from '../config/crypto';
import { IMAGE_URL, REACT_APP_API_PORT } from '../Api';
import axios from 'axios';
export default function CourseEnrollment(props) {
    const navigate = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState([])
    const [isLoading, setisLoading] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [formType, setformType] = useState("signup");
    const [sname, setsname] = useState("")
    const [semail, setsemail] = useState("")
    const [spassword, setspassword] = useState("")
    const [lemail, setlemail] = useState("")
    const [lpassword, setlpassword] = useState("")
    const user = getDecryptedData("user")

    const getData = async () => {
        try {
            setisLoading(true);
            const res = await axios.get(
                `${REACT_APP_API_PORT}user/course/course-details/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            );
            setisLoading(false);
            if (res.data.status) {
                setData(res.data.data);
            }

        } catch (err) {
            setisLoading(false);
            console.log(err);
        }
    };


    useEffect(() => {
        getData()
    }, []);


    const urlToFile = async (photoURL, fileName) => {
        try {
            const response = await fetch(photoURL);
            const blob = await response.blob();
            const file = new File([blob], fileName, { type: blob.type });
            return file;
        } catch (error) {
            console.error("Error converting photoURL to file:", error);
        }
    };



    const handleGoogleSignup = async () => {
        try {
            const data = await signInWithPopup(auth, provider);
            if (!data) {
                props.setAlertBox(true);
                props.showAlert("Something went wrong!", "error");
                return;
            }

            let updateData = {
                name: data?.user?.displayName,
                email: data?.user?.email,
                phone: data?.user?.phoneNumber,
            };

            if (data?.user?.photoURL) {
                const profileImage = await urlToFile(data?.user?.photoURL, `image-${Date.now()}-${data?.user?.displayName}.jpg`);
                if (profileImage) {
                    updateData.image = profileImage;
                }
            }

            setisLoading(true);
            const res = await axios.post(`${REACT_APP_API_PORT}user/auth/social-login`, updateData);

            if (res.data.status) {
                storeEncryptedData("user", res.data.data);
                storeEncryptedData("token", res.data.jwtoken);

                // Introduce a delay before making the second request
                setTimeout(async () => {
                    try {
                        const res2 = await axios.post(
                            `${REACT_APP_API_PORT}user/course/order/user-course-purchase/${id}`, {},
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": res.data.jwtoken,
                                },
                            }
                        );
                        setisLoading(false);
                        if (res2.data.status) {
                            props.setAlertBox(true);
                            props.showAlert(res2.data.message, "success");
                            navigate('/my-profile');
                        }
                    } catch (err) {
                        setisLoading(false);
                        if (err.response?.data?.status === false) {
                            props.setAlertBox(true);
                            props.showAlert(err.response.data.message, "error");
                        }
                    }
                }, 2000); // 2-second delay

            }
        } catch (err) {
            console.log(err);
            setisLoading(false);
            if (err.response?.data?.status === false) {
                props.setAlertBox(true);
                props.showAlert(err.response.data.message, "error");
            }
        }

        console.log('Google Signup Clicked');
    };

    const handleSignUp = async (event) => {
        event.preventDefault()
        try {
            setisLoading(true)
            const res = await axios.post(`${REACT_APP_API_PORT}user/auth/signup-through-course`, {
                name: sname,
                email: semail,
                password: spassword
            })
            // setisLoading(false)
            if (res.data.status) {
                storeEncryptedData("user", res.data.data);
                storeEncryptedData("token", res.data.jwtoken);

                setTimeout(async () => {
                    try {
                        console.log(res.data.jwtoken)
                        const res2 = await axios.post(
                            `${REACT_APP_API_PORT}user/course/order/user-course-purchase/${id}`, {},
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": res?.data?.jwtoken,
                                },
                            }
                        );
                        setisLoading(false);
                        if (res2.data.status) {
                            props.setAlertBox(true);
                            props.showAlert(res2.data.message, "success");
                            navigate('/my-profile');
                        }
                    } catch (err) {
                        setisLoading(false);
                        if (err.response?.data?.status === false) {
                            props.setAlertBox(true);
                            props.showAlert(err.response.data.message, "error");
                        }
                    }
                }, 2000); // 2-second delay

            }
        }
        catch (err) {
            console.log(err)
            setisLoading(false)
            if (err.response.data.status === false) {
                props.setAlertBox(true)
                props.showAlert(err.response.data.message, "error")
            }
        }
    }

    const handleLogin = async (event) => {
        event.preventDefault()
        try {
            setisLoading(true)
            const res = await axios.post(`${REACT_APP_API_PORT}user/auth/login`, {
                email: lemail,
                password: lpassword
            })
            // setisLoading(false)
            if (res.data.status) {
                storeEncryptedData("user", res.data.data);
                storeEncryptedData("token", res.data.jwtoken);
              
                setTimeout(async () => {
                    try {
                        console.log(res.data.jwtoken)
                        const res2 = await axios.post(
                            `${REACT_APP_API_PORT}user/course/order/user-course-purchase/${id}`, {},
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": res?.data?.jwtoken,
                                },
                            }
                        );
                        setisLoading(false);
                        if (res2.data.status) {
                            props.setAlertBox(true);
                            props.showAlert(res2.data.message, "success");
                            navigate('/my-profile');
                        }
                    } catch (err) {
                        setisLoading(false);
                        if (err.response?.data?.status === false) {
                            props.setAlertBox(true);
                            props.showAlert(err.response.data.message, "error");
                        }
                    }
                }, 2000); // 2-second delay

            }
        }
        catch (err) {
            console.log(err)
            setisLoading(false)
            if (err.response.data.status === false) {
                props.setAlertBox(true)
                props.showAlert(err.response.data.message, "error")
            }
        }
    }

    const handlePurchaseFreeCourse = async()=>{
        try {
            const token = getDecryptedData("token")
            setisLoading(true);
            const res2 = await axios.post(
                `${REACT_APP_API_PORT}user/course/order/user-course-purchase/${id}`, {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                }
            );
            setisLoading(false);
            if (res2.data.status) {
                props.setAlertBox(true);
                props.showAlert(res2.data.message, "success");
                navigate('/my-profile');
            }
        } catch (err) {
            setisLoading(false);
            if (err.response?.data?.status === false) {
                props.setAlertBox(true);
                props.showAlert(err.response.data.message, "error");
            }
        }
    }

    return (
        <>
            <Loader isLoading={isLoading} />
            {/* <TopBar /> */}
            <Header />
            <div className="flex flex-col md:flex-row items-center justify-center min-h-screen p-4">
                {/* Left Section */}
                <div className="w-full md:w-1/2  p-2 lg:p-6 rounded-lg max-w-lg">
                    <img
                        src={data?.banner ? IMAGE_URL + data?.banner : '/images/placeholder-image.png'}
                        alt="Course Thumbnail"
                        className="w-full h-64 object-fit:cover border"
                    />

                    <span className="block text-2xl font-bold mt-4 mb-2 text-[#36394D]">{data?.course_name}</span>
                    <span className="text-black my-3 text-[#36394D]">
                        {
                            (data?.section1_description) ?
                                <p className="text-lg  max-w-3xl mb-6 leading-none">
                                    <div dangerouslySetInnerHTML={{ __html: data?.section1_description }} />
                                </p>
                                :
                                <p className="text-lg text-center max-w-3xl mb-6 leading-none">
                                    Course description is not available
                                </p>
                        }
                    
                    </span>

                    <div className='flex justify-between my-3'>
                        <div>
                            <span className="text-lg font-semibold mt-2  text-[#36394D]">{data?.payment_type}</span>

                        </div>
                        <div>
                            <span className="text-lg font-semibold mt-2  text-[#36394D]">{data?.payment_type === "Paid" ? `₹ ${data?.amount}` : "₹ 0.00"}</span>

                        </div>
                    </div>
                    <hr className='text-gray-300'></hr>
                </div>

                <div className="hidden md:block h-96 border-l border-gray-100 mx-6"></div>

                {/* Right Section */}
                {
                    (user) ?
                        <div className='w-full md:w-1/2  p-2 lg:p-6 rounded-lg max-w-lg'>
                            <div>
                                <h2 className="text-2xl font-bold text-gray-800 text-center mb-4  text-[#36394D] ">
                                    Your Account
                                </h2>
                                <div className="bg-gray-100 p-4 rounded-lg">
                                    <p className="text-gray-700 text-lg">
                                        <span className="font-medium">Name:</span> {user.name}
                                    </p>
                                    <p className="text-gray-700 text-lg mt-1">
                                        <span className="font-medium">Email:</span> {user.email}
                                    </p>
                                </div>

                            </div>
                            <button
                               type='button'
                               onClick={handlePurchaseFreeCourse}
                                className="mt-2 border-2 border-customBlue  bg-blue-600  px-4 py-3 rounded text-white   hover:bg-background-primary transition text-[15px] font-bold uppercase w-full"
                            >
                                Purchase Course
                            </button>
                        </div>
                        :
                        <>


                            <div className="w-full md:w-1/2  p-2 lg:p-6 rounded-lg max-w-lg">
                                <span className="block text-2xl font-bold mt-4 mb-2 text-[#36394D] mb-3">Sign up to enroll</span>
                                <button onClick={handleGoogleSignup} className="w-full flex items-center justify-center gap-2 py-2 border rounded-lg shadow-sm hover:bg-gray-100">
                                    <FcGoogle size={24} />
                                    <span className="text-black font-medium">Continue with Google</span>
                                </button>
                                <div className="text-center my-4 text-gray-600 font-semibold">OR</div>
                                {
                                    (formType === 'signup') ?
                                        <form className="space-y-4" onSubmit={handleSignUp}>
                                            <div>
                                                <label className="block text-sm font-medium text-black">Name</label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter your name"
                                                    required
                                                    value={sname}
                                                    onChange={(e) => setsname(e.target.value)}
                                                    className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-200 text-black"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-black">Email</label>
                                                <input
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    required
                                                    value={semail}
                                                    onChange={(e) => setsemail(e.target.value)}
                                                    className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-200 text-black"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-black">Password</label>
                                                <input
                                                    type="password"
                                                    placeholder="Enter your password"
                                                    required
                                                    value={spassword}
                                                    onChange={(e) => setspassword(e.target.value)}
                                                    maxLength={16}
                                                    className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-200 text-black"
                                                />
                                            </div>
                                   
                                            <button
                                                type="submit"
                                                className="mt-2 border-2 border-customBlue  bg-blue-600  px-4 py-3 rounded text-white   hover:bg-background-primary transition text-[15px] font-bold uppercase w-full"
                                            >
                                                Sign Up
                                            </button>

                                            <p className="text-center text-sm text-gray-300 mt-6 ">
                                                Already have an account?{' '}
                                                <span onClick={() => setformType('login')} className="text-blue-400 hover:underline cursor-pointer">
                                                    Sign in
                                                </span>
                                            </p>
                                        </form>
                                        :
                                        <form className="space-y-4" onSubmit={handleLogin}>
                                            <div>
                                                <label className="block text-sm font-medium text-black">Email</label>
                                                <input
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    required
                                                    value={lemail}
                                                    onChange={(e) => setlemail(e.target.value)}
                                                    className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-200 text-black"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-black">Password</label>
                                                <input
                                                    type="password"
                                                    placeholder="Enter your password"
                                                    required
                                                    value={lpassword}
                                                    onChange={(e) => setlpassword(e.target.value)}
                                                    className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-200 text-black"
                                                />
                                            </div>
                                 
                                            <button
                                                type="submit"
                                                className="mt-2 border-2 border-customBlue  bg-blue-600  px-4 py-3 rounded text-white   hover:bg-background-primary transition text-[15px] font-bold uppercase w-full"
                                            >
                                                Login
                                            </button>

                                            <p className="text-center text-sm text-gray-300 mt-6 ">
                                                Don’t have an account?{' '}
                                                <span onClick={() => setformType("signup")} className="text-blue-400 hover:underline cursor-pointer">
                                                    Sign up
                                                </span>
                                            </p>
                                        </form>
                                }

                            </div>
                        </>
                }
            </div>
            <CallToAction />
            <Footer />
            <MobileFooter />
        </>
    );
}
